const baseURL = "https://vo1urbmb5k.execute-api.ap-south-1.amazonaws.com/dev/api/purchaseOrder/"
export const getAllPO = baseURL+"getAllPurchaseOrders"
